import clinicalAssessment from '../encounter/questionnaires/clinical-assessment';
import medicationDSS from '../encounter/questionnaires/medication-dss';

export const initialState = () => ({
  ...medicationDSS.reduce((accumulator, currentValue) => ({
    ...accumulator, [currentValue.key]: currentValue.defaultValue,
  }), {}),
  ...clinicalAssessment.reduce((accumulator, currentValue) => ({
    ...accumulator, [currentValue.key]: currentValue.defaultValue,
  }), {}),
});

export default initialState();
